import { FormControl, FormControlLabel, Radio, RadioGroup, Box } from '@mui/material'
import capitalize from 'lodash/capitalize'
import styled from 'styled-components'

const StyledRadioGroup = styled(RadioGroup)`
  display: flex;
  flex-direction: row;
  gap: 8px;
  flex-wrap: wrap;

  @media (max-width: 600px) {
    flex-direction: column;
  }
`

const StyledFormControlLabel = styled(FormControlLabel)`
  margin: 0;
  padding: 10px 16px;
  border: 2px solid ${(props) => (props.checked ? '#6779e3' : '#e2e8f0')};
  border-radius: 10px;
  background: ${(props) => (props.checked ? 'rgba(103, 121, 227, 0.08)' : '#ffffff')};
  transition: all 0.2s ease;
  min-width: 120px;
  justify-content: center;

  &:hover {
    border-color: #6779e3;
    background: rgba(103, 121, 227, 0.04);
  }

  .MuiRadio-root {
    color: #94a3b8;
    padding: 4px 8px;

    &.Mui-checked {
      color: #6779e3;
    }
  }

  .MuiFormControlLabel-label {
    font-size: 14px;
    font-weight: 500;
    color: ${(props) => (props.checked ? '#1e293b' : '#64748b')};
    margin-left: 8px;
  }
`

export default function ScreeningSingleChoice({ question, answer, onChange }) {
  const choices = question?.choices || ['Yes (हाँ)', 'No (नहीं)']

  const handleRadioChange = (e) => {
    const value = e.target.value
    onChange({
      ...answer,
      response: value,
    })
  }

  return (
    <FormControl component="fieldset" fullWidth>
      <StyledRadioGroup
        value={answer?.response || ''}
        onChange={handleRadioChange}
        row
      >
        {choices.map((choice) => (
          <StyledFormControlLabel
            key={choice}
            value={choice}
            control={<Radio />}
            label={capitalize(choice)}
            checked={answer?.response === choice}
          />
        ))}
      </StyledRadioGroup>
    </FormControl>
  )
}
